<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    persistent
    lazy
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <form-input :name="name" :onChanged="changed" :title="title" @focus="modal = true"></form-input>
    </template>
    <v-time-picker v-model="time" format="24hr" full-width>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">Отмена</v-btn>
      <v-btn flat color="primary" @click="saveTime">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/edit-form/new-items/Input'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')
  export default {
    name: 'Calendar',
    data () {
      return {
        time: null,
        modal: false,
        changed: false
      }
    },
    watch: {
      time(val) {
        let item = JSON.parse(JSON.stringify(this.item))
        item[this.name] = val;
        this.setItem(item);
      }
    },
    props: ['name', 'min', 'title'],
    computed: {
      ...mapState([
        'item'
      ]),
      minDate () {
        if (this.min) {
          return this.item[this.min]
        }
      }
    },
    created() {
      this.time = this.item[this.name]
    },
    methods: {
      ...mapMutations([
        'setField',
        'setItemField',
        'setItem'
      ]),
      saveTime() {
        this.$refs.dialog.save(this.time)
        this.changed = true;
      },
      hide () {
        this.$emit('close')
      },
      isValidDate (date) {
        return date instanceof Date && !isNaN(date.getTime())
      }
    },
    components: {
      FormInput
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/edit-form/TimePicker.vue